//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import EnhancedDataTable from '../../components/MaterialUi/DataTable/EnhancedDataTable';
import * as actions from '../../redux/demeter/actions';
import Button from 'material-ui/Button';
import KeyboardArrowUp from 'material-ui-icons/KeyboardArrowUp';
import KeyboardArrowDown from 'material-ui-icons/KeyboardArrowDown';
import ModeEdit from 'material-ui-icons/ModeEdit';
import Add from 'material-ui-icons/Add';
import Delete from 'material-ui-icons/Delete';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import ActionConfirmDialog2 from '../../components/ActionConfirmDialog/ActionConfirmDialog2';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';

import type { InvoiceItemsForm$Props } from './flowTypes'
                        
const columnData = [
    { id: 'id', numeric: false, disablePadding: false, label: 'No.', customCol: true, style: { paddingLeft: '5px',paddingRight: '1px', width: '15%'}, noHeader: true },
    { id: 'item_row_index', numeric: false, disablePadding: false, label: 'No.', customCol: true, style: { paddingLeft: '5px',paddingRight: '5px', width: '5%'}, noHeader: false },
    { id: 'item_desc', numeric: false, disablePadding: true, label: 'Description', customCol: true, style: { paddingLeft: '10px', paddingRight: '10px',  width: '40%'},noHeader: false },
    { id: 'item_qty', numeric: false, disablePadding: true, label: 'Quantity', customCol: true, style: { paddingLeft: '11px', paddingRight: '11px',  width: '12%'},noHeader: false },
    { id: 'item_price', numeric: false, disablePadding: true, label: 'Price', customCol: true, style: { paddingLeft: '11px', paddingRight: '11px',  width: '14%'},noHeader: false },
    { id: 'item_total', numeric: false, disablePadding: true, label: 'Item Total', customCol: true, style: { paddingLeft: '11px', paddingRight: '11px',  width: '14%'},noHeader: false },
];

const editDemeterItem=(id,props)=>{
    const { demeter } = props;
    const demeterItem = demeter.demeterItems.find(item => item.id==id)
    
    props.editDemeterItem(demeterItem);
}

const moveDownDemeterItem=(id,props)=>{
    const { jwt } = props;
    
    props.moveDownDemeterItem(jwt,id);
}

const moveUpDemeterItem=(id,props)=>{
    const { jwt } = props;

    props.moveUpDemeterItem(jwt,id);
}

const deleteDemeterItem=(id,props)=>{
    props.selectDemeterItemId(id);
    props.deleteActionDialog();
}

const submitConfirmDelete=(props)=>{
    const { jwt,demeter } = props;
    props.deleteDemeterItem(jwt,demeter.demeterItemId);
    props.closeDeleteDialog();
}

const customCol = (col,row,props)=>{
    const { demeter } = props;
    switch(col.id){
      case 'id':
        const itemIndex=demeter.demeterItems.findIndex(item => item.id==row.id)
        const isFirstItem=itemIndex==0?true:false;
        const isLastItem=(itemIndex==demeter.demeterItems.length-1 && demeter.page==demeter.pages)?true:false;
       
        return (
           <div>
             <Tooltip id="tooltip-icon" title="Move Up">
              <div>  
                <Button variant="fab" disabled={isFirstItem} mini aria-label="Move Up" onClick={()=> moveUpDemeterItem(row.id,props)}  >
                    <KeyboardArrowUp />
                </Button>
              </div> 
             </Tooltip>
             <Tooltip id="tooltip-icon" title="Move Down">
               <div>    
                <Button variant="fab" mini disabled={isLastItem} aria-label="Move Down" onClick={()=> moveDownDemeterItem(row.id,props)} >
                    <KeyboardArrowDown />
                </Button>
               </div>
             </Tooltip>
             <Tooltip id="tooltip-icon" title="Delete">
               <div>    
                <Button variant="fab" mini  aria-label="Delete" onClick={()=> deleteDemeterItem(row.id,props)} >
                    <Delete />
                </Button>
               </div>
             </Tooltip>
           </div>    
        )
      case 'item_total':
         let itemTotal=row[col.id]
         if (itemTotal) {
            itemTotal=parseFloat(itemTotal) 
            itemTotal=itemTotal.toFixed(2)
         }
         return (
            <span onClick={()=>editDemeterItem(row.id,props)} 
                className='editLink'>
                {itemTotal}
            </span>
         )   
      case 'item_qty':
         let itemQty=row[col.id]   
         if (itemQty) {
            itemQty=parseFloat(itemQty)
            itemQty=itemQty.toFixed(4)
         }
         return (
            <span onClick={()=>editDemeterItem(row.id,props)} 
                className='editLink'>
                {itemQty}
            </span>
         )   
      case 'item_price':
         let itemPrice=row[col.id]   
         if (itemPrice) {
            itemPrice=parseFloat(itemPrice)
            itemPrice=itemPrice.toFixed(4)
         }
         return (
            <span onClick={()=>editDemeterItem(row.id,props)} 
                className='editLink'>
                {itemPrice}
            </span>
         )     
      default:  
        return (
            <span onClick={()=>editDemeterItem(row.id,props)} 
                className='editLink'>
                {row[col.id]}
            </span>
        )
    }
}

const addButtonOnclick=(e,props)=>{
    e.preventDefault();
    props.openAddInvItemForm();
}

const isSelected = (index,props) => {
    const { demeter } = props;
    if (typeof demeter.invoiceItemSelectedIndex=='number' && index === demeter.invoiceItemSelectedIndex) {
        return true;
    }else {
        return false;
    }
}

class InvoiceItemsForm extends React.Component<InvoiceItemsForm$Props> {
    componentWillMount(){
        this.refreshData();
    }

    componentDidMount(){
    }

    componentDidUpdate(){
        const { demeter } = this.props;
        if (demeter.anyChanges){
            this.refreshData();
        }
    }

    refreshData(){
        const { demeter,jwt,taskAcceptedInfoId } = this.props;
        const { page,pageSize,sortField,sortOrder } = demeter;
        
        this.props.getDemeterItems(jwt,(page:any),(pageSize:any),(sortField:any),(sortOrder:any),taskAcceptedInfoId);
    }

    handleChangePage = (event, page) => {
        const nextPage=page+1;    
        const { jwt,demeter } = this.props;
        this.props.setPage(jwt,demeter,nextPage);
    };
  
    handleChangeRowsPerPage = event => {
        const pageSize=event.target.value;
        const { jwt,demeter } = this.props;
        this.props.setPageSize(jwt,demeter,pageSize);
    };

    handleRequestSort = (event, property) => {
        let order = 'desc';

        const { jwt,demeter  } = this.props;
        const { sortField,sortOrder } = demeter;
    
        if (sortField === property && sortOrder === 'desc') {
            order = 'asc';
        }
        
        //this.props.sortData(gs.jwtToken,wrk,property,order)
    };

    handleClick = (event, id)=> {
    }

    handleSearch=(search)=>{
    }

    render(){
        const { demeter } = this.props;
    
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col-sm'>
                        <EnhancedDataTable 
                            title={'Invoice Items'}    
                            //selected={selected}
                            totalRows={demeter.count}
                            order={demeter.sortOrder}
                            orderBy={demeter.sortField}
                            rowsPerPage={demeter.pageSize}
                            page={(demeter.page:any) - 1}
                            data={demeter.demeterItems}
                            handleSearch={this.handleSearch}
                            columnData={columnData}
                            //handleSelectAllClick={this.handleSelectAllClick}  
                            handleRequestSort={this.handleRequestSort}
                            handleClick={this.handleClick}
                            //handleKeyDown={this.handleKeyDown}
                            handleChangePage={this.handleChangePage}
                            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                            tableStyle={{width: '100%',minWidth: 800}}
                            customColFunc={customCol}
                            showToolbar={true}
                            addNewOnclick={(e)=> addButtonOnclick(e,this.props)}
                            clientUiProps={this.props}    
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-sm'>
                        <ActionConfirmDialog2 
                            title={'Invoice Items'}
                            message={'Are you sure you want to delete this item?'}
                            submitFunc={()=> submitConfirmDelete(this.props)}
                        /> 
                    </div>
                </div>    
            </div> 
        )
    }
}

const mapStateToProps:any = (state, ownProps) => {
    return {
        demeter: state.demeter
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
        getDemeterItems: (jwt,page,pageSize,sortField,sortOrder,taskAcceptedInfoId) => {
            dispatch(actions.getDemeterItems(jwt,page,pageSize,sortField,sortOrder,taskAcceptedInfoId))
        },
        setPage: (jwt,demeter,page)=>{
          dispatch(actions.setPage(jwt,demeter,page))
        },
        setPageSize: (jwt,demeter,pageSize)=>{
          dispatch(actions.setPageSize(jwt,demeter,pageSize))
        },
        editDemeterItem: (demeterItem)=>{
            dispatch(actions.editDemeterItem(demeterItem))
        }, 
        openAddInvItemForm: () => {
            dispatch(actions.openAddInvItemForm())  
        },
        moveDownDemeterItem: (jwt,id)=>{
            dispatch(actions.moveDownDemeterItem(jwt,id))
        },
        moveUpDemeterItem: (jwt,id)=>{
            dispatch(actions.moveUpDemeterItem(jwt,id))
        },
        deleteDemeterItem: (jwt,id)=>{
            dispatch(actions.deleteDemeterItem(jwt,id))
        },
        deleteActionDialog: ()=> {
            dispatch(actConfDlgActions.openDialog2())    
        },
        closeDeleteDialog: ()=> {
            dispatch(actConfDlgActions.closeDialog2())    
        },
        selectDemeterItemId: (id)=> {
            dispatch(actions.selectDemeterItemId(id))    
        }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(InvoiceItemsForm);


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/InvoiceItemsForm.js